module.exports = __webpack_public_path__ + "assets/lighttpd.4f6f1f3e.svg";